module.exports = __webpack_public_path__ + "img/25_77.299480c7.png";